module.exports = __webpack_public_path__ + "media/beep-long.2a359912.mp3";